
export default function RelationshipSection() {
  const achievements = [
    {
      number: "300台以上",
      label: "累計導入実績",
      description: "(ドローン・自動操舵・水管理)"
    },
    {
      number: "98%",
      label: "お客様満足度",
      description: "(導入後アンケート)"
    },
    {
      number: "80%",
      label: "リピート率",
      description: "(追加機器導入率)"
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-8">
            お客様と共に、農業の未来を創る
          </h2>
          <div className="max-w-4xl mx-auto">
            <p className="text-lg text-gray-700 leading-relaxed">
              お客様は単なる「購入者」でなく、共に農業の未来を変えていくパートナー。一人ひとりの経営課題に真剣に向き合い、最適ソリューションを一緒に考え、導入後も成功まで伴走。私たちと出会ったすべてのお客様に笑顔になっていただくこと。それが目指す姿です。
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {achievements.map((achievement, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg text-center">
              <div className="text-5xl lg:text-6xl font-bold text-[#2A6041] mb-4">
                {achievement.number}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                {achievement.label}
              </h3>
              <p className="text-gray-600">
                {achievement.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
